import React, { useState, useEffect } from 'react'
import DataTable from 'react-data-table-component'
import styled from 'styled-components'
import axios from 'axios'
import TmsHeader from '../TmsComponents/TmsHeader'
import TmsSidebar from '../TmsComponents/TmsSidebar'
import Dropdown from 'react-bootstrap/Dropdown'

const columns = [
  { name: 'Participant', selector: (row) => row.user, sortable: true },
  { name: 'User Email', selector: (row) => row.user_email, sortable: true },
  { name: 'Title', selector: (row) => row.training, sortable: true },
  {
    name: 'Enrollment Date',
    selector: (row) => row.enrollment_date,
    sortable: true,
  },
]

const customStyles = {
  header: {
    style: { fontSize: '1.2rem', fontWeight: 'bold', padding: '15px' },
  },
  headCells: {
    style: {
      fontSize: '1rem',
      fontWeight: 'bold',
      color: '#333',
      backgroundColor: '#f7f7f7',
    },
  },
  cells: { style: { padding: '8px', fontSize: '0.95rem' } },
  pagination: {
    style: {
      fontSize: '0.9rem',
      color: 'black',
      backgroundColor: '#fff',
      borderRadius: '4px',
      padding: '5px',
    },
    pageButtonsStyle: {
      color: '#fff',
      padding: '0 10px',
      '&:hover:not(:disabled)': { backgroundColor: '#ff8383' },
      '&:focus': { outline: 'none' },
    },
  },
}

const Container = styled.div`
  padding: 20px;
  border-radius: 10px;
  background-color: #f9f9f9;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  margin: 10px;
  flex-grow: 1;

  @media (max-width: 768px) {
    padding: 15px;
    margin: 0;
  }
`

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

const TmsParticipants = () => {
  const [data, setData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [trainings, setTrainings] = useState([])
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState('')
  const [selectedTraining, setSelectedTraining] = useState(null)
  const [selectedTrainingName, setName] = useState('')

  const URL = 'https://tdtlworld.com/dss-kaas-backend/'

  useEffect(() => {
    const fetchTrainings = async () => {
      const token = localStorage.getItem('jwttoken')
      try {
        const response = await axios.get(`${URL}tms/training/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        setTrainings([...response.data.trainings])
      } catch (error) {
        console.error('Error fetching training list:', error)
      }
    }

    fetchTrainings()
  }, [])

  useEffect(() => {
    if (selectedTraining) {
      const fetchParticipants = async () => {
        const token = localStorage.getItem('jwttoken')
        setLoading(true)
        try {
          const response = await axios.get(
            `${URL}tms/training/${selectedTraining}/enrollments/`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )
          setData([...response.data.enrollments])
          setFilteredData([...response.data.enrollments])
        } catch (error) {
          console.error('Error fetching participants data:', error)
        } finally {
          setLoading(false)
        }
      }

      fetchParticipants()
    }
  }, [selectedTraining])

  useEffect(() => {
    const lowercasedSearch = search.toLowerCase()
    const filtered = data.filter(
      (row) =>
        row.user.toLowerCase().includes(lowercasedSearch) ||
        row.user_email.toLowerCase().includes(lowercasedSearch) ||
        row.enrollment_date.toLowerCase().includes(lowercasedSearch)
    )
    setFilteredData(filtered)
  }, [search, data])

  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <TmsSidebar />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <TmsHeader />
        <Wrapper>
          <Container>
            <h4 className='text-center mb-4'>All Participants List</h4>
            <Dropdown
              onSelect={(eventKey) => {
                const [name, id] = eventKey.split(',')
                setName(name)
                setSelectedTraining(id)
              }}
              style={{ marginBottom: '16px' }}
            >
              <Dropdown.Toggle variant='success' id='dropdown-basic'>
                {selectedTraining
                  ? `${selectedTrainingName}`
                  : 'Select Training'}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {trainings.map((training) => (
                  <Dropdown.Item
                    key={training.training_id}
                    eventKey={[training.title, training.training_id]}
                  >
                    {training.title} (ID: {training.training_id})
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {selectedTraining ? (
              <>
                <input
                  type='text'
                  placeholder='Search by name, email, or date...'
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{
                    marginBottom: '10px',
                    padding: '8px',
                    width: '100%',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                  }}
                />
                <DataTable
                  columns={columns}
                  data={filteredData}
                  pagination
                  progressPending={loading}
                  noDataComponent='No data available in table'
                  customStyles={customStyles}
                />
              </>
            ) : (
              <p className='text-center mt-4'>
                Please select training to view the list.
              </p>
            )}
          </Container>
        </Wrapper>
      </div>
    </div>
  )
}

export default TmsParticipants
